import { Component, ViewEncapsulation } from '@angular/core';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-skeleton',
	templateUrl: './skeleton.html',
})
export class SkeletonComponent {}
